import React from 'react';
import { useParams, useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Wrapper from '../Wrapper';
import { LaunchProvider } from './contexts/LaunchContext';
import ReportsPage from './ReportsPage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
    },
  },
});

export default function ReportsTabsWrapperContainer({ hostTabChange, getLaunchUrl, launchActivity, ...props }) {
  const params = useParams();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const navigateLocal = useNavigate();

  const courseId = props.courseId || params.courseId || '';
  const reportType = params.reportType || 'overview';
  const itemId = params.itemId || null;
  const subItemId = params.subItemId || null;
  const search = location.search;
  
  const handleTabChange = (tabName, searchStr) => {
    if (hostTabChange) {
      hostTabChange(tabName, searchStr);
    }

    // only navigate internally if its a reports route
    // other routes (people, assignments, performance, etc.) are handled by the cw
    if (tabName?.startsWith('reports')) {
      const path = `/courses/${courseId}/${tabName}${searchStr || ''}`;
      navigateLocal(path);
    }
  };
  
  // Determine the actual path pattern based on the URL
  let pathPattern = '/courses/:courseId/reports';
  if (params.reportType) {
    pathPattern = '/courses/:courseId/reports/type/:reportType';
    if (params.itemId) {
      pathPattern = '/courses/:courseId/reports/type/:reportType/:itemId';
      if (params.subItemId) {
        pathPattern = '/courses/:courseId/reports/type/:reportType/:itemId/:subItemId';
      }
    }
  }
  
  // Create a match object that includes all needed parameters
  const match = {
    params: {
      courseId,     // The course ID from the URL
      id: courseId, // Alias for backward compatibility
      tab: 'reports', // If code relies on a tab parameter
      reportType,   // The report type (or default)
      itemId,       // The item ID (or default)
      subItemId     // The sub-item ID (or default)
    },
    path: pathPattern, // The determined path pattern
    url: location.pathname // The actual URL path
  };

  return (
    <Wrapper params={params} {...props} useRedux={true}>
      <QueryClientProvider client={queryClient}>
        <LaunchProvider getLaunchUrl={getLaunchUrl} launchActivity={launchActivity}>
          <ReportsPage 
            location={location}
            navigate={navigateLocal}
            search={search}
            searchParams={Object.fromEntries(searchParams)}
            match={match}
            onTabChange={handleTabChange}
          />
        </LaunchProvider>
      </QueryClientProvider>
    </Wrapper>
  );
}
